import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import { AvatarProfileImageFragmentDoc } from '../../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PostMentionableUsersQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type PostMentionableUsersQuery = { __typename?: 'Query', PostMentionableUsers: { __typename?: 'Employees', objects: Array<{ __typename?: 'Employee', id: number, name: string, firstName: string, lastName: string, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }> } };


export const PostMentionableUsersDocument = gql`
    query PostMentionableUsers($search: String, $pagination: PaginationInput) {
  PostMentionableUsers(search: $search, pagination: $pagination) {
    objects {
      id
      name
      firstName
      lastName
      profileImage {
        ...AvatarProfileImage
      }
    }
  }
}
    ${AvatarProfileImageFragmentDoc}`;

/**
 * __usePostMentionableUsersQuery__
 *
 * To run a query within a React component, call `usePostMentionableUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostMentionableUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostMentionableUsersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePostMentionableUsersQuery(baseOptions?: Apollo.QueryHookOptions<PostMentionableUsersQuery, PostMentionableUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostMentionableUsersQuery, PostMentionableUsersQueryVariables>(PostMentionableUsersDocument, options);
      }
export function usePostMentionableUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostMentionableUsersQuery, PostMentionableUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostMentionableUsersQuery, PostMentionableUsersQueryVariables>(PostMentionableUsersDocument, options);
        }
export type PostMentionableUsersQueryHookResult = ReturnType<typeof usePostMentionableUsersQuery>;
export type PostMentionableUsersLazyQueryHookResult = ReturnType<typeof usePostMentionableUsersLazyQuery>;
export type PostMentionableUsersQueryResult = Apollo.QueryResult<PostMentionableUsersQuery, PostMentionableUsersQueryVariables>;